import { createContext, useContext } from "react";

/**
 * Provides a DOM element for Radix portals (Dialog, Popover, etc.) to render
 * into. Inside a Shadow DOM this points to a node within the shadow tree so
 * that portaled content still receives the widget's scoped styles. When the
 * widget runs in regular DOM the value is `undefined` and portals fall back
 * to `document.body` as usual.
 */
export const PortalContainerContext = createContext<HTMLElement | undefined>(
  undefined
);

export function usePortalContainer(): HTMLElement | undefined {
  return useContext(PortalContainerContext);
}
